export class CustomFilterDef {
    constructor(
        private id: string,
        private caption: string,
        private validation: string,
        private value: string
    ) { }

    public get ID() {
        return this.id;
    }
    public get Caption() {
        return this.caption;
    }
    public get Validation() {
        return this.validation.toUpperCase();
    }
    public get Value() {
        return this.value;
    }
}
